import { snakeCase } from "lodash";
import FormSelect from "react-bootstrap/FormSelect";
import useListConfiguredAlerts from "../../hooks/useListConfiguredAlerts";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import Widget from "../../../../forms/components/Widget";
import { IConfiguredAlertItem, SubscriptionHashes } from "../../@types";
import { route } from "../../../../shim/jsbridge";
import { useSubscriptionHashes } from "../../hooks";
import { handleAlertLimitCheck } from "../../utils";
import { SUBSCRIPTION_URL_PARAMS } from "../../const";
import { RenderWhen } from "../../../../components";

type SubscriptionSelectorProps = {
  hashes: SubscriptionHashes;
  onClose: () => void;
};

const SubscriptionSelector = ({
  hashes,
  onClose
}: SubscriptionSelectorProps) => {
  const {
    configuredAlertsList,
    totalResultCount,
    isLoadingConfiguredAlertsList
  } = useListConfiguredAlerts();

  const { setSubscriptionHashes } = useSubscriptionHashes();

  const alertOptions = configuredAlertsList.map(
    (alert: IConfiguredAlertItem) => (
      <option
        value={alert.id}
        key={alert.id}
        data-testid={`subscription_selection_item_${snakeCase(alert.name)}`}
      >
        {alert.name}
      </option>
    )
  );

  const handleSelectOption = (id: number) => {
    handleAlertLimitCheck(totalResultCount, () => {
      setSubscriptionHashes(hashes);
      if (!!id) {
        window.open(
          `${route("edit_alert", { alert_id: id })}?${
            SUBSCRIPTION_URL_PARAMS.HASHES
          }=true`,
          "_blank"
        );
      } else {
        window.open(
          `${route("create_alert")}?${SUBSCRIPTION_URL_PARAMS.HASHES}=true`,
          "_blank"
        );
      }
      onClose();
    });
  };

  return (
    <div>
      <RenderWhen
        condition={!isLoadingConfiguredAlertsList}
        fallback={<LoadingOverlay />}
      >
        <Widget
          name="subscriptionName"
          label="Alert"
          vertical
          as={FormSelect}
          onChange={e => {
            handleSelectOption(Number(e.target.value));
          }}
        >
          <option value="" />
          <option
            value={0}
            data-testid="subscription_selection_item_create_new"
          >
            Create New
          </option>
          <option disabled value="">
            -----------------
          </option>
          {alertOptions}
        </Widget>
      </RenderWhen>
    </div>
  );
};

export default SubscriptionSelector;
